<template>
  <div>
    <EUIPageLoading v-if="$auth.loading" />
    <SettlementWidget v-else />
    <GlobalError />
  </div>
</template>

<script>
import EUIPageLoading from '@eui-page/loading';
import GlobalError from './components/organism/global-error';

export default {
  name: 'MainApp',
  components: {
    EUIPageLoading,
    GlobalError,
    SettlementWidget: () => import('./widgets/settlement')
  }
};
</script>
